import { ChangeEvent, useCallback } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useSYS3020_R01Store, { defaultSYS3020_R01Filter } from "./Store_SYS3020_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { getUserBySearch } from "src/apis/authApi";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { CodeSearchModalProps } from "src/types/code-search";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {
	yesnoOptions: SysCodeDto[];
	fetchData: () => Promise<void>;
}

export const SearchSection_SYS3020_R01 = ({
	fetchData
}: Props) => {
	const { 
		SYS3020_R01Filter, setSYS3020_R01Filter,
	} = useSYS3020_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();
	const { systemList } = useCommonCodeStore();

	const userInfoHandleFoucsId = 'infoUserInput_search';

	// 업무 시스템 선택 핸들러
	const handleSystemChange = (value: string) => {
		setSYS3020_R01Filter({ menuCd: value === 'all' ? '' : value });
	};

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'userId',
			category: '사용자',
			focusId: userInfoHandleFoucsId,
			responseMapping: {
				userId: 'userId',
				userNm: 'userNm',
			},
			searchFunction: async (code: string) => {
				const userResponse = await getUserBySearch('');
				return userResponse.data.data.find(value => value.userId === code);
			},
			extraFilter: () => ({
				userId: SYS3020_R01Filter.userId || '',
				userNm: SYS3020_R01Filter.userNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SYS3020_R01Filter,
		setEditData: setSYS3020_R01Filter,
		defaultData: defaultSYS3020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SYS3020_R01_search'
	});

	return (
		<SearchSectionForm>
		
			<SearchDropDownForm<SysCodeDto>
				label="업무시스템"
				value={SYS3020_R01Filter.menuCd || 'all'}
				optionList={systemList}
				onChangeValue={handleSystemChange}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min	-w-[60px]",
					selectStyle: "w-[100px] min-w-[90px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]",
				}}
			/>
			
			<SearchCodeModalForm
				label="사용자"
				value={SYS3020_R01Filter.userId}
				valueLabel={SYS3020_R01Filter.userNm}
				handleFoucsId={userInfoHandleFoucsId}
				onChange={getFieldHandlers('userId').onChange}
				onDoubleClick={getFieldHandlers('userId').onDoubleClick} 
				onKeyDown={getFieldHandlers('userId').onEnterKeyDown}
			/>
		
		 
			
		</SearchSectionForm>
	);
}; 